export default __webpack_public_path__ + "static/media/macarronada.8e7c63a1.png";